import { createSlice } from '@reduxjs/toolkit';
const filterModeOfPayment = [
  { label: 'Cash', value: 'Cash' },
  { label: 'Credit/Debit Card', value: 'Credit/Debit Card' },
  { label: 'Paytm', value: 'Paytm' },
  { label: 'PhonePe', value: 'PhonePe' },
  { label: 'Gpay', value: 'Gpay' },
];
const initialState = {
  expenses: [],
  filteredExpenses: [],
  displayedExpenses: [],
  initialExpenseData: {
    date: '',
    typeOfExpense: '',
    others: '',
    staffId: '',
    amountPaid: '',
    modeOfPayment: '',
    recipientName: '',
    description: '',
  },
  expenseTypes: [{ label: 'Salary' }, { label: 'Staff Advance' }, { label: 'Others' }],
  staffList: [],
  filters: {
    search: '',
    expenseType: '',
    filterSelection: [],
  },
  pagination: {
    currentPage: 1,
    itemsPerPage: 10,
    totalItems: 0,
    totalPages: 1,
  },
  loading: false,
  error: null,
};

const expenseSlice = createSlice({
  name: 'expenses',
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    setAllExpenses: (state, action) => {
      state.expenses = action.payload;
      applyFilters(state);
    },
    setExpenseTypes: (state, action) => {
      state.expenseTypes = action.payload;
    },
    setStaffList: (state, action) => {
      state.staffList = action.payload;
    },
    updateExpenseData: (state, action) => {
      state.initialExpenseData = {
        ...state.initialExpenseData,
        ...action.payload,
      };
    },
    resetExpenseData: (state) => {
      state.initialExpenseData = initialState.initialExpenseData;
    },
    setFilters: (state, action) => {
      state.filters = {
        ...state.filters,
        ...action.payload,
      };
      applyFilters(state);
    },
    setCurrentPage: (state, action) => {
      state.pagination.currentPage = action.payload;
      paginate(state);
    },
   setPagination: (state, action) => {
  state.pagination = {
    ...state.pagination,
    ...action.payload,
  };
  // Recalculate total pages
  state.pagination.totalPages = Math.ceil(
    state.pagination.totalItems / state.pagination.itemsPerPage
  );
  paginate(state);
},
    resetFilters: (state) => {
      state.filters = initialState.filters;
      state.pagination.itemsPerPage = 10;
      applyFilters(state);
    },
  },
});

function applyFilters(state) {
  const { search, filterSelection } = state.filters;
  let result = [...state.expenses];
  if (filterSelection.length > 0) {
    result = result.filter((item) => {
      const isModeOfPaymentMatch = filterSelection.some(
        (filter) =>
          filterModeOfPayment.find((option) => option.value === filter)?.value ===
          item.modeOfPayment,
      );
      const isTypeOfExpenseMatch = filterSelection.some(
        (filter) =>
          state.expenseTypes.some((type) => type.label === filter) && filter === item.typeOfExpense,
      );
      return isModeOfPaymentMatch || isTypeOfExpenseMatch;
    });
  }

    const cleanSearch = (search || '').trim();

    if (cleanSearch) {
    const lowerSearch = cleanSearch.toLowerCase().replace(/[\s\-()]/g, '');

    const fuzzyMatch = (text) => {
      const lowerText = text?.toLowerCase().replace(/[\s\-()]/g, '');
      if (!lowerText) return false;

      let textIndex = 0;
      let searchIndex = 0;
      while (textIndex < lowerText.length && searchIndex < lowerSearch.length) {
        if (lowerText[textIndex] === lowerSearch[searchIndex]) {
          searchIndex++;
        }
        textIndex++;
      }
      return searchIndex === lowerSearch.length;
    };

    result = result.filter(
      (item) =>
        fuzzyMatch(item?.recipientName) ||
        fuzzyMatch(item?.description) ||
        fuzzyMatch(item?.modeOfPayment) ||
        fuzzyMatch(item?.typeOfExpense)
    );
  }
  state.pagination.currentPage = 1;
  state.filteredExpenses = result;
  state.pagination.totalItems = result.length;
  state.pagination.totalPages = Math.ceil(result.length / state.pagination.itemsPerPage) || 1;
  paginate(state);
}

function paginate(state) {
  const { currentPage, itemsPerPage } = state.pagination;
  const start = (currentPage - 1) * itemsPerPage;
  const end = start + itemsPerPage;
  state.displayedExpenses = state.filteredExpenses.slice(start, end);
}

export const {
  setLoading,
  setError,
  setAllExpenses,
  setExpenseTypes,
  setStaffList,
  updateExpenseData,
  resetExpenseData,
  setFilters,
  setCurrentPage,
  setPagination,
  resetFilters,
} = expenseSlice.actions;

export default expenseSlice.reducer;
